
define('SageDotCom/DataLayer/Util/urlHelper',["jquery"], function ($) {
    "use strict";

    var defaultHashDelimiter = "/";

    function createSetRegExp(urlParam) {
        /*
        [\\?|&]                      Character set - Match any of these characters: [?|&]
        (urlParam=[^&]+|$)          Capturing parenthesis. (x) matches x and remembers the match.
            urlParam=               Explicit match
            [^&]+                   Negated character set. The + quantifier causes this item to be matched 1 or more times (greedy).
            |                       Or
            $                       Matches end of input.
        */
        return new RegExp("([\\?|&])(" + urlParam + "=[^&#]+|$)", "gi");
    }

    function createGetRegExp(urlParam) {
        return new RegExp("[\\?|&]" + urlParam + "=([^&#]+|$)", "gi");
    }
    

    function urlHelper() {
        return undefined;
    }

    urlHelper.prototype.getHashAsObject = function getHashAsObject(delimiter) {
        return decodeURI(window.location.hash.slice(1))
            .split(delimiter || defaultHashDelimiter)
            .reduce(function (result, value) {
                value = value.split("=");
                if (value.length === 2) {
                    result[value[0]] = value[1];
                }

                return result;
            }, {});
    };

    urlHelper.prototype.getObjectAsHash = function getObjectAsHash(obj, delimiter) {
        var hash = "", del = delimiter || defaultHashDelimiter;
        $.each(obj, function (key, value) {
            hash = hash + key + "=" + value + del;
        });

        return encodeURI(hash.substring(0, hash.length - del.length)); // cut off trailing delimiter
    };

    urlHelper.prototype.getHashValue = function getHashValue(paramName, delimiter) {
        return this.getHashAsObject(delimiter || defaultHashDelimiter)[paramName];
    };

    urlHelper.prototype.setHashValue = function setHashValue(location, paramName, value, delimiter) {
        /**
         * location    - required, https://developer.mozilla.org/en-US/docs/Web/API/Location item
         * paramName   - required, parameter name
         * value       - required, parameter value
         * delimeter   - optional, character delimiting hash parameters
         */

        if (typeof(location.hash) !== "string") {
            throw new Error("location must implement Location");
        }

        var hash = this.getHashAsObject(delimiter);
        if (!value) {
            delete hash[paramName];
        } else {
            hash[paramName] = value;
        }

        location.hash = this.getObjectAsHash(hash, delimiter || defaultHashDelimiter);
    };

    urlHelper.prototype.getUrlParameters = function getUrlParameters(location, urlParam) {
        urlParam = decodeURIComponent(urlParam);
        var regExp = createGetRegExp(urlParam), url = location.href, results = [], value = regExp.exec(url);
        while (value) {
            results.push(value[1]);
            value = regExp.exec(url);
        }

        return results.map(decodeURIComponent);
    };

    urlHelper.prototype.setUrlParameters = function setUrlParameter(location, urlParam, value) {
        value = encodeURIComponent(value);
        if (location === undefined || location === null) {
            throw new Error("No location URL implemented");
        }

        var url = location.href, regExp = createSetRegExp(urlParam);

        // Clear out all current instances of this param in the query string
        if (regExp.test(url)) {
            url = url.replace(regExp, "$1");
            // If query string was something like ?param=value&otherparam=othervalue and ew removed param=value then we would end up with ?&
            if (url.indexOf("?&") > -1) {
                url = url.replace("?&", "?");
            }
            if (url.indexOf("&&") > -1) {
                url = url.replace("&&", "&");
            }
        }

        if (value) {
            if (url.indexOf("?") < 0) {
                url += "?";
            } else if (new RegExp("[\\?&]").test(url.slice(-1)) === false) {
                url += "&";
            }
            url += (urlParam + "=" + value);
        }

        if (window.location.pathname === location.pathname && window.host === location.host) {
            window.history.replaceState(null, document.title, url);
        }
        return url;
    };

    urlHelper.prototype.isFile = function isFile(href) {
        var retVal = { isFile: false };

        var parser = document.createElement('a');
        parser.href = href;

        var finalPart = parser.pathname.split('/').pop();

        if (finalPart.indexOf('.') > -1) {
            retVal.isFile = true;
            retVal.fileName = decodeURIComponent(finalPart);
            retVal.extension = finalPart.split('.').pop();
        }

        return retVal;
    }

    urlHelper.prototype.removeHash = function() {
        var scrollV, scrollH, loc = window.location;
        if ("pushState" in history)
            history.pushState("", document.title, loc.pathname + loc.search);
        else {
            // Prevent scrolling by storing the page's current scroll offset
            scrollV = $(window).scrollTop();
            scrollH = $(window).scrollLeft();

            loc.hash = "";

            // Restore the scroll offset, should be flicker free
            $(window).scrollTop(scrollV);
            $(window).scrollLeft(scrollH);
        }
    };

    urlHelper.prototype.SortDirectionKey = "direction";
    urlHelper.prototype.SortTypeKey = "sort";

    return new urlHelper(); // singleton
});

